export default "__VITE_ASSET__mWNiS$is__"